import { initializeAdjustTracker, trackAdjustEvent } from './adjust'
import { initializeFirebaseTracker, trackFirebaseEvent } from './firebase'
import { appConfig } from '~/constants/appConfig'
import { adjustInstance, firebaseInstance } from '~/services/instances'

let sessionTag: string | null = null

/**
 * Check if Firebase debug mode should be enabled
 * Can be enabled via:
 * 1. URL parameter: ?firebase-debug=true
 * 2. Environment variable: VITE_FIREBASE_DEBUG_MODE=true
 * 3. localStorage: firebase-analytics-debug=true
 */
const shouldEnableFirebaseDebugMode = (): boolean => {
  if (typeof window === 'undefined') return false

  // Check URL parameter
  const urlParams = new URLSearchParams(window.location.search)
  if (urlParams.get('firebase-debug') === 'true') {
    return true
  }

  // Check environment variable
  if (import.meta.env.VITE_FIREBASE_DEBUG_MODE === 'true') {
    return true
  }

  // Check localStorage
  if (localStorage.getItem('firebase-analytics-debug') === 'true') {
    return true
  }

  return false
}

export const initializeTrackers = async () => {
  try {
    if (appConfig.tracker.adjust.enabled) {
      await initializeAdjustTracker(adjustInstance)
    }
    if (appConfig.tracker.firebase.enabled) {
      const enableDebugMode = shouldEnableFirebaseDebugMode()
      await initializeFirebaseTracker({
        ...firebaseInstance,
        enableDebugMode,
      })
    }
    console.log('Analytics trackers initialized successfully')
  } catch (error) {
    console.error('Failed to initialize analytics trackers:', error)
  }
}

export const trackEvent = async (
  eventName: string,
  eventProperties: Record<string, unknown> = {},
) => {
  if (!appConfig.enableAnalytics) {
    console.log('Analytics is disabled')
    return
  }

  const payload = {
    ...eventProperties,
    ...(sessionTag ? { sessionTag } : {}),
  }

  try {
    trackFirebaseEvent(eventName, payload)
    trackAdjustEvent(eventName, payload)

    console.log('Tracking event:', eventName, payload)
  } catch (error) {
    console.error('Failed to track event:', error)
  }
}

export const setSessionTag = (tag: string) => {
  sessionTag = tag
  console.log('Session tag set:', tag)
}
